// Mobile Grid Toggle Functionality
document.addEventListener('DOMContentLoaded', () => {
  const mobileToggle = document.getElementById('mobile-grid-toggle');
  const productGrid = document.getElementById('product-grid');
  const toggleButtons = document.querySelectorAll('.mobile-grid-toggle__button');

  function injectCss() {
    if (!document.getElementById('two-col-style')) {
      const style = document.createElement('style');
      style.id = 'two-col-style';
      style.textContent = `
        .product-item__wishlist {
          top: 20px !important;
        }

        .product-item__properties-tags {
          position: absolute;
          top: 1rem;
          left: 0.5rem;
          z-index: 5;
          display: flex;
          flex-direction: column;
          gap: 4px;
          transition: transform .25s cubic-bezier(0,0,.58,1);
        }

        .product-item:has(.swym-button) .product-item__preview-tags {
          right: 0.5rem;
        }

        .product-grid[data-mobile-columns="2"] .product-item__preview-tag,
        .product-grid[data-mobile-columns="2"] .product-item__properties-tag {
          font-size: .5rem;
        }
      `;
      document.head.appendChild(style);
    }
  }

  function removeCss() {
    const style = document.getElementById('two-col-style');
    if (style) style.remove();
  }

  function setGridColumns(columns) {
    // Update active state
    toggleButtons.forEach((btn) => {
      btn.classList.remove('mobile-grid-toggle__button--active');
      if (btn.dataset.columns === columns) {
        btn.classList.add('mobile-grid-toggle__button--active');
      }
    });

    // Apply grid layout via data attribute
    if (productGrid) {
      productGrid.setAttribute('data-mobile-columns', columns);
    }

    // Inject CSS only if mobile + 2 columns
    if (window.innerWidth <= 768 && columns === '2') {
      injectCss();
    } else {
      removeCss();
    }
  }

  if (mobileToggle && productGrid) {
    // Set default state from localStorage or default to 2 column
    const savedColumns = localStorage.getItem('mobile-grid-columns') || '2';
    setGridColumns(savedColumns);

    // Remove the preload style to show the grid (mobile only)
    const preloadStyle = document.getElementById('grid-preload');
    if (preloadStyle) {
      preloadStyle.remove();
    }

    // Handle toggle button clicks
    toggleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const { columns } = button.dataset;
        setGridColumns(columns);
        localStorage.setItem('mobile-grid-columns', columns);
      });
    });

    // Re-check on resize (mobile ↔ desktop bascule)
    window.addEventListener('resize', () => {
      const currentColumns = productGrid.getAttribute('data-mobile-columns') || '2';
      setGridColumns(currentColumns);
    });
  }
});
